import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    labelName: {
      maxWidth: '288px',
      padding: theme.spacing(0, 1),

      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.neutral.white,

      display: 'inline',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      justifyContent: 'flex-start',
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'NavigationBarItems' }
);
